/**
 * Created by pandemio on 1/28/19.
 */
import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import ApiCalls from '../../custom-classes/api-calls';
import {Col, Row, Input} from 'reactstrap';
import {Translate} from "react-localize-redux";

/**
 * Handle the checkboxes of the countries isos
 */
class CheckboxCountries extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

            checkedItems: new Map(),
            checkboxes : [],
            checkedValues: [],
            checkedRegionsValues: [],
            planAvailableIsos: [],
            selectAll: false, // If select all,
            mounted: false,
            showAll: true,
            disabled: props.disabled
        };

        if(typeof props !== 'undefined')
        {
            // Prepare the regions and countries checked
            let regionsSelected = [];
            let countriesSelected = [];
            for(let i=0; i < props.data.planAvailableIsos.length; i++)
            {
                if(typeof props.data.planAvailableIsos[i].StateIso !== 'undefined'
                    && props.data.planAvailableIsos[i].StateIso !== null
                    && props.data.planAvailableIsos[i].StateIso.trim() !== ''
                )
                    regionsSelected.push(props.data.planAvailableIsos[i].StateIso + '|' + props.data.planAvailableIsos[i].CountryIso);
                else {
                    countriesSelected.push(props.data.planAvailableIsos[i].CountryIso);
                }
            }

            this.state = {
                checkedItems: new Map(),
                checkboxes : [],
                checkedValues: countriesSelected,
                checkedRegionsValues: regionsSelected,
                planAvailableIsos: props.data.planAvailableIsos,
                selectAll: props.data.selectAll,
                disabled: props.disabled
            };
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeRegion = this.handleChangeRegion.bind(this);
        this.addRegions = this.addRegions.bind(this);
        this.handleShowAll = this.handleShowAll.bind(this);
    }

    /**
     * Sets the component to receive props
     */
    componentWillReceiveProps(nextProps){
        if(
            (typeof nextProps.data.checkedValues !== 'undefined' && nextProps.data.checkedValues.length > 0)
            ||
            (typeof nextProps.data.checkedRegionsValues !== 'undefined' && nextProps.data.checkedRegionsValues.length > 0)
        ) {
            this.setState({
                checkedValues: nextProps.data.checkedValues,
                checkedRegionsValues: nextProps.data.checkedRegionsValues,
                disabled: nextProps.disabled
            },()=>{
                this.checkSelectedRegionsInRead();
            });
        }

        if(nextProps.data.selectAll !== this.state.selectAll){
            this.setState({
                selectAll : nextProps.data.selectAll,
                disabled: nextProps.disabled
            },()=>{
                this.selectAllCountries(nextProps.data.selectAll);
            });
        }
    }

    /**
     * Mounts the data. Call the data from the server and sets the data to the list
     */
    mountData(){
        let totalOfRegions = 0;
        let totalOfRegionsChecked = 0;
        let totalOfCountries = 0;
        let totalOfCountriesChecked = 0;

        // This is promise
        let apiCall = ApiCalls.getCountryFullDetails(true, true);

        // After the api call, fill the data
        apiCall.then((data)=> {
            let options = [];
            let dataReturned = data.Countries;

            // Now fill the selections
            for (let i = 0; i < dataReturned.length; i++) {

                totalOfCountries += 1; // Sum this total, only to compare if all the countries are selected
                let countrySelected = false; // To evaluate if the country was selected
                if(this.state.checkedValues.indexOf(dataReturned[i].IsoCode1) > -1
                    || this.state.selectAll) // We check if the country was selected or the selected all checkmark is selected
                {
                    totalOfCountriesChecked += 1; // Sum this total of selected contries to compare if all the countries were selected
                    countrySelected = true; // Sets true as the country was selected.
                    this.state.checkedValues.push(dataReturned[i].IsoCode1); // Add to the checked values the country added.
                    this.state.checkedItems.set(dataReturned[i].IsoCode1, true); // This is to mark the country as checked (UI)
                }

                let optionToAdd = {
                    name: dataReturned[i].CountryNameTrans[0].Desc,
                    key: dataReturned[i].IsoCode1,
                    label: dataReturned[i].IsoCode1,
                    checked: countrySelected,
                    regions: []
                };

                // Now evaluate the regions and if any of them were marked
                let optionsRegions = [];
                for (let j = 0; j < dataReturned[i].Regions.length; j++) {
                    totalOfRegions += 1; // Sum the total of regions

                    if(this.state.checkedRegionsValues.indexOf(dataReturned[i].Regions[j].IsoCode) > -1
                        || this.state.selectAll) // Check if we have to add the region as selected.
                    {
                        totalOfRegionsChecked += 1; // Sum to the total of selected regions
                        optionsRegions.push({
                            name: dataReturned[i].Regions[j].Name,
                            key: dataReturned[i].Regions[j].IsoCode + '|' + dataReturned[i].IsoCode1,
                            label: dataReturned[i].Regions[j].IsoCode + '|' + dataReturned[i].IsoCode1,
                            checked: true
                        });
                    }
                    else
                    {
                        optionsRegions.push({
                            name: dataReturned[i].Regions[j].Name,
                            key: dataReturned[i].Regions[j].IsoCode + '|' + dataReturned[i].IsoCode1,
                            label: dataReturned[i].Regions[j].IsoCode + '|' + dataReturned[i].IsoCode1,
                            checked: false
                        });
                    }
                    optionToAdd.regions = optionsRegions;
                }
                options.push(optionToAdd); // Push it, so it does exists in the array already (don't change this position)
            }

            this.setState({checkboxes: options,
                selectAll: totalOfRegions === totalOfRegionsChecked && totalOfCountries === totalOfCountriesChecked},()=>
            {
                this.props.updateParent(this.state);
                return this.state;
            });
        });
    }

    /**
     * Action when the component will mount
     */
    componentDidMount(){
        this.mountData();
    }

    /**
     * Removes a value from array
     * @param array
     * @param xToRemove
     * @returns {*}
     */
    removeFromArray(array, xToRemove){
        for(let i = array.length - 1; i >= 0; i--)
        {
            if(array[i] === xToRemove) {
                array.splice(i, 1);
            }
        }
        return array;
    }

    /**
     * Add a value to an array
     * @param array
     * @param xToAdd
     * @returns {*}
     */
    insertInArrayIfNotExists(array, xToAdd){
        if(array.includes(xToAdd))
            return array;
        else {
            array.push(xToAdd);
            return array;
        }
    }

    checkSelectedRegionsInRead(){
        for(let i=0; i < this.state.checkboxes.length; i++)
        {
            if(this.state.checkboxes[i].regions.length > 0)
            {
                for(let j=0; j < this.state.checkboxes[i].regions.length; j++) {
                    if (this.state.checkedRegionsValues.includes(this.state.checkboxes[i].regions[j].label)){
                        this.state.checkboxes[i].regions[j].checked = true;
                    }
                }
            }
        }
    }

    /**
     * Action when the checkbox changes
     * @param e
     */
    handleChange(e) {
        this.addCountry(e.target.value, e.target.checked);
    }

    /**
     * Select the all countries when the checkbox is checked.
     * @param isChecked If it's checked or not
     */
    selectAllCountries(isChecked){
        let originalCheckboxes = this.state.checkboxes;
        // Clear original
        this.setState({
            checkboxes: [],
            checkedItems: new Map(),
            checkedValues: [],
            checkedRegionsValues: []
        },()=>{
            let newCheckboxes = [];
            let newCheckedItems = new Map();
            let newCheckedValues = [];
            let newCheckedRegionsValues = [];
            for(let i=0; i < originalCheckboxes.length; i++)
            {
                let itemToAdd = {
                    name : originalCheckboxes[i].name,
                    key : originalCheckboxes[i].key,
                    label : originalCheckboxes[i].label,
                    checked : isChecked,
                    regions : originalCheckboxes[i].regions
                };

                newCheckedItems.set(itemToAdd.key, isChecked);

                for(let j=0; j < itemToAdd.regions.length; j++)
                {
                    itemToAdd.regions[j].checked = isChecked;
                    if(isChecked)
                        newCheckedRegionsValues.push(itemToAdd.regions[j].key);
                }
                newCheckboxes.push(itemToAdd);

                // Add the values
                if(isChecked)
                    newCheckedValues.push(itemToAdd.key);
            }
            this.setState({
                checkboxes: newCheckboxes,
                checkedItems: newCheckedItems,
                checkedValues: newCheckedValues,
                checkedRegionsValues: newCheckedRegionsValues
            },()=>{
                this.props.updateParent(this.state);
                return this.state;
            });
        });
    }

    /**
     * To remove multiple regions when a country is selected
     * @param countryIso
     * @returns {{checkedItems: Map, checkboxes: Array, checkedValues: Array, checkedRegionsItems: Map, checkboxesRegions: Array, checkedRegionsValues: Array, planAvailableIsos: (Array|*), selectAll: (boolean|*)}|*}
     */
    removeRegions(countryIso){
        for(let i=0; i < this.state.checkboxes.length;i++)
        {
            if(this.state.checkboxes[i].key === countryIso) {

                for (let j = 0; j < this.state.checkboxes[i].regions.length; j++) {
                    this.changeRegion(this.state.checkboxes, this.state.checkboxes[i].regions[j].key, false);
                }
                break;
            }
        }
        this.props.updateParent(this.state);
        return this.state;
    }

    /**
     * Adds multiple regions when country is selected
     * @param countryIso
     */
    addRegions(countryIso){
        for(let i=0; i < this.state.checkboxes.length;i++)
        {
            if(this.state.checkboxes[i].key === countryIso) {

                for (let j = 0; j < this.state.checkboxes[i].regions.length; j++) {
                    this.changeRegion(this.state.checkboxes, this.state.checkboxes[i].regions[j].key, true);
                }
                break;
            }
        }
        this.props.updateParent(this.state);
        return this.state;
    }

    /**
     * Adds the country when the value is checked
     * @param value
     * @param isChecked
     * @returns {{checkedItems: Map, checkboxes: Array, checkedValues: Array, checkedRegionsValues: Array, planAvailableIsos: Array, selectAll: boolean, mounted: boolean, showAll: boolean, disabled: *}|*}
     */
    addCountry(value, isChecked)
    {
        // First, we set the checked items to true or false
        this.state.checkedItems.set(value, isChecked);

        // Second, in the checkboxes array, update the value
        for(let i=0; i < this.state.checkboxes.length; i++)
        {
            if(this.state.checkboxes[i].key === value)
            {
                if(isChecked)
                {
                    // Add it to the array if doesn't exist
                    this.state.checkedValues.push(value);
                    // Add the regions
                    this.addRegions(value);
                }
                else
                {
                    // Remove
                    let index = this.state.checkedValues.indexOf(value);
                    if (index > -1)
                        this.state.checkedValues.splice(index, 1);
                    this.removeRegions(value);
                }

                // Finally, update the checkbox checked value
                this.state.checkboxes[i].checked = isChecked;
            }
        }
        this.setState(this.state); // Force
        this.props.updateParent(this.state);
        return this.state;
    }

    /**
     * Handles the show all checkbox
     * @param e
     */
    handleShowAll(e){
        this.setState({
            showAll: e.target.checked
        });
    }

    /**
     * Generic function when a function is selected or unselected.
     * @param parentArray
     * @param value
     * @param isChecked
     * @returns {{checkedItems: Map, checkboxes: Array, checkedValues: Array, checkedRegionsItems: Map, checkboxesRegions: Array, checkedRegionsValues: Array, planAvailableIsos: (Array|*), selectAll: (boolean|*)}|*}
     */
    changeRegion(parentArray, value, isChecked)
    {
        let countryCode = value.substr(value.indexOf("|") + 1);  // Gets the text part
        for(let i=0; i < parentArray.length; i++)
        {
            if(parentArray[i].key === countryCode){
                for(let j=0; j < parentArray[i].regions.length;j++)
                {
                    if(parentArray[i].regions[j].key === value)
                    {
                        if(isChecked)
                            this.state.checkedRegionsValues.push(value);
                        else
                        {
                            // remove it from index
                            let index = this.state.checkedRegionsValues.indexOf(value);
                            if (index > -1) {
                                this.state.checkedRegionsValues.splice(index, 1);
                            }
                        }
                        parentArray[i].regions[j].checked = isChecked;
                        break;
                    }
                }
                break;
            }
        }
        this.setState({checkboxes: parentArray}); // Force a replace
        this.props.updateParent(this.state);
        return this.state;
    }

    /**
     * Handles when a region is selected
     * @param e
     */
    handleChangeRegion(e){
       this.changeRegion(this.state.checkboxes, e.target.value, e.target.checked);
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm={{size:10, offset:1}} md={{size:10, offset:1}} lg={{size:10, offset:1}}>
                        <Col sm={{size:12}} md={{size:12}} lg={{size:12}}>
                        <Input type="checkbox" onChange={this.handleShowAll} checked={this.state.showAll}/>
                        <Translate id="iso-codes-applier.show-all" />
                        </Col>
                    </Col>
                </Row>
                {
                    this.state.showAll ?
                    <Row>
                        {
                            this.state.checkboxes.map(item => (
                                <Col sm={{size: 12}} md={{size:12}} lg={{size:12}} key={item.key}>
                                        <Checkbox name={item.name}
                                                  value={item.key}
                                                  disabled={this.state.disabled}
                                                  checked={this.state.checkedItems.get(item.key)}
                                                  onChange={this.handleChange} />
                                                <small><label key={item.key + item.name}> {item.name} </label></small>
                                        {
                                            item.regions.length > 0 ?
                                                item.regions.map(itemRegions => (
                                                        <Col xs={{size: 10, offset: 1}}
                                                             sm={{size: 10, offset: 1}}
                                                             md={{size: 10, offset: 1}}
                                                             lg={{size: 10, offset: 1}}>
                                                            <Checkbox name={itemRegions.name}
                                                                      value={itemRegions.key}
                                                                      checked={itemRegions.checked}
                                                                      onChange={this.handleChangeRegion}
                                                                      disabled={this.state.disabled}
                                                            />
                                                            <small>
                                                                <label key={itemRegions.key + itemRegions.name}>
                                                                    {itemRegions.name}
                                                                </label>
                                                            </small>
                                                        </Col>
                                                ))
                                                : null
                                        }
                                </Col>
                            ))
                        }
                    </Row> : null }
            </div>
        );
    }
}

export default CheckboxCountries;